module.exports = __webpack_public_path__ + "img/14.0f60d8a2.png";